import { useDeck } from '@/app/context/DeckContext/useDeck';
import FileEditIcon from '@/icons/FileEditIcon';
import FlashcardsIcon from '@/icons/FlashcardsIcon';
import QuizIcon from '@/icons/QuizIcon';
import { useRouter } from 'next/router';
import React from 'react';
import { DeckPages } from '../models';
import DownloadButton from '../../download-button/DownloadButton';
import ArticleIcon from '@/app/icons/ArticleIcon';
import { useSettings } from '@/app/context/SettingsContext/useSettings';
import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';

export default function MenuNavigation({ currentPage }) {
  const router = useRouter();
  const { selectedDeck } = useDeck();
  const { theme } = useSettings();

  const { trackEvent, analyticsInstance } = useAnalytics();

  const inactiveClass = 'btn btn-ghost';
  const activeClass =
    'btn btn-outline btn-disabled btn-active bordered border-white';

  return (
    <div className="flex gap-2">
      <div
        data-tip="Multiple Choice"
        style={{ height: 48, width: 58 }}
        className="tooltip tooltip-bottom"
      >
        <div
          onClick={() => {
            trackEvent(analyticsInstance, 'deck_header_click_quiz', {
              deck_id: selectedDeck.id
            });
            router.replace(`/app/${selectedDeck.id}/quiz`);
          }}
          className={
            currentPage === DeckPages.Quiz ? activeClass : inactiveClass
          }
        >
          <QuizIcon invert={theme === 'light'} />
        </div>
      </div>
      <div
        data-tip="Flashcards"
        style={{ height: 48, width: 58 }}
        className="tooltip tooltip-bottom"
      >
        <div
          onClick={() => {
            trackEvent(analyticsInstance, 'deck_header_click_flashcards', {
              deck_id: selectedDeck.id
            });
            router.replace(`/app/${selectedDeck.id}/flashcards`);
          }}
          className={
            currentPage === DeckPages.Flashcards ? activeClass : inactiveClass
          }
        >
          <FlashcardsIcon />
        </div>
      </div>
      <div
        data-tip="Study Guide"
        style={{ height: 48, width: 58 }}
        className="tooltip tooltip-bottom"
      >
        <div
          onClick={() => {
            trackEvent(analyticsInstance, 'deck_header_click_study_guide', {
              deck_id: selectedDeck.id
            });
            router.replace(`/app/${selectedDeck.id}/studyGuide`);
          }}
          className={
            currentPage === DeckPages.StudyGuide ? activeClass : inactiveClass
          }
        >
          <ArticleIcon />
        </div>
      </div>
      {!selectedDeck.isImageOcclusion && (
        <div
          data-tip="Download Flashcards"
          style={{ height: 48, width: 58 }}
          className="tooltip tooltip-bottom"
        >
          <DownloadButton
            isLanding={false}
            iconOnly={true}
            onClick={() => {
              trackEvent(analyticsInstance, 'deck_header_click_download', {
                deck_id: selectedDeck.id
              });
            }}
          />
        </div>
      )}
      <div
        data-tip="View All / Edit"
        style={{ height: 48, width: 58 }}
        className="tooltip tooltip-bottom"
      >
        <div
          onClick={() => {
            trackEvent(analyticsInstance, 'deck_header_click_edit', {
              deck_id: selectedDeck.id
            });
            router.replace(`/app/${selectedDeck.id}/edit`);
          }}
          className={
            currentPage === DeckPages.Edit ? activeClass : inactiveClass
          }
        >
          <FileEditIcon />
        </div>
      </div>
    </div>
  );
}
